var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceDueGbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1344.283,
    height: 1901.349,
    viewBox: "0 0 1344.283 1901.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31624",
    "data-name": "Rectangle 31624",
    width: 1344.283,
    height: 1900.349,
    transform: "translate(0 2)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "INVOICE_DUE_GBP",
    "data-name": "INVOICE DUE GBP",
    transform: "translate(0 -1.04)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31623",
    "data-name": "Rectangle 31623",
    width: 1344.28,
    height: 1900.798,
    transform: "translate(0 1.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12700",
    "data-name": "Group 12700",
    transform: "translate(0 -0.96)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8304",
    transform: "translate(-146.017 1138.893)",
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8186",
    transform: "translate(444.758 513.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8560",
    d: "M169.348,794.991l-37.058,64.2H280.543l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-132.29 -730.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8205",
    transform: "translate(518.874 641.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8579",
    d: "M239.225,787.64l-37.058,64.2-37.058,64.2H313.363l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-165.11 -787.64)",
    fill: "#56aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8206",
    transform: "translate(370.621 641.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8580",
    d: "M173.575,787.64l-37.058,64.2-37.058,64.2H247.713l-37.058-64.2L173.6,787.64h0Z",
    transform: "translate(-99.46 -787.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8207",
    transform: "translate(222.391 641.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8581",
    d: "M107.935,787.64l-37.058,64.2-37.058,64.2H182.073l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-33.82 -787.64)",
    fill: "#008843"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8208",
    transform: "translate(74.138 641.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8582",
    d: "M5.228,851.841l-37.058,64.2H116.4l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(31.83 -787.64)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8210",
    transform: "translate(1111.862 641.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8584",
    d: "M501.815,787.64l-37.057,64.2-37.058,64.2H575.953l-37.057-64.2-37.08-64.2Z",
    transform: "translate(-427.7 -787.64)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8211",
    transform: "translate(963.609 641.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8585",
    d: "M399.108,851.841l-37.058,64.2H510.3l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-362.05 -787.64)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8212",
    transform: "translate(815.357 641.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8586",
    d: "M370.515,787.64l-37.058,64.2-37.058,64.2H444.653l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-296.4 -787.64)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8213",
    transform: "translate(667.126 641.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8587",
    d: "M267.818,851.841l-37.058,64.2H379.013l-37.058-64.2L304.9,787.64l-37.058,64.2Z",
    transform: "translate(-230.76 -787.64)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8214",
    transform: "translate(296.506 641.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8588",
    d: "M177.835,851.831l37.058-64.2H66.64l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-66.64 -787.63)",
    fill: "#008843"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8215",
    transform: "translate(444.736 641.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8589",
    d: "M206.418,916.033l37.058-64.2,37.058-64.2H132.28l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-132.28 -787.63)",
    fill: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8216",
    transform: "translate(592.989 641.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8590",
    d: "M309.125,851.831l37.058-64.2H197.93l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-197.93 -787.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8217",
    transform: "translate(741.219 641.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8591",
    d: "M374.765,851.831l37.058-64.2H263.57l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-263.57 -787.63)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8218",
    transform: "translate(889.472 641.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8592",
    d: "M403.358,916.033l37.058-64.2,37.058-64.2H329.22l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-329.22 -787.63)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8219",
    transform: "translate(1037.702 641.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8593",
    d: "M469,916.033l37.058-64.2,37.058-64.2H394.86l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-394.86 -787.63)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8220",
    transform: "translate(148.253 641.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8594",
    d: "M75.105,916.033l37.058-64.2,37.058-64.2H.99l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-0.99 -787.63)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8221",
    transform: "translate(296.506 513.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8595",
    d: "M103.7,794.982l-37.058,64.2H214.893l-37.058-64.2-37.058-64.2L103.72,794.959Z",
    transform: "translate(-66.64 -730.78)",
    fill: "#56aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8222",
    transform: "translate(148.253 513.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8596",
    d: "M38.048,794.969.99,859.17H149.243l-37.058-64.179-37.058-64.2L38.07,794.969Z",
    transform: "translate(-0.99 -730.79)",
    fill: "#008843"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8223",
    transform: "translate(0.023 513.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8597",
    d: "M-27.592,794.991l-37.058,64.2H83.58l-37.058-64.2L9.465,730.79l-37.058,64.2Z",
    transform: "translate(64.65 -730.79)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8224",
    transform: "translate(1185.977 513.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8598",
    d: "M497.578,794.991l-37.058,64.2H608.773l-37.058-64.2-37.058-64.2-37.057,64.2Z",
    transform: "translate(-460.52 -730.79)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8225",
    transform: "translate(1037.725 513.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8599",
    d: "M431.928,794.991l-37.058,64.2H543.123l-37.057-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-394.87 -730.79)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8226",
    transform: "translate(889.472 513.567)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8600",
    d: "M366.278,794.991l-37.058,64.2H477.473l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-329.22 -730.79)",
    fill: "#008843"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8227",
    transform: "translate(741.242 513.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8601",
    d: "M300.638,794.991l-37.058,64.2H411.833l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-263.58 -730.79)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8228",
    transform: "translate(370.621 513.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8602",
    d: "M210.655,794.982l37.058-64.2H99.46l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-99.46 -730.78)",
    fill: "#008843"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8229",
    transform: "translate(667.104 513.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8603",
    d: "M341.945,794.982,379,730.78H230.75l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-230.75 -730.78)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8230",
    transform: "translate(815.334 513.544)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8604",
    d: "M370.528,859.183l37.058-64.2,37.058-64.2H296.39l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-296.39 -730.78)",
    fill: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8231",
    transform: "translate(963.587 513.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8605",
    d: "M436.178,859.183l37.058-64.2,37.058-64.2H362.04L399.1,794.959l37.058,64.2h0Z",
    transform: "translate(-362.04 -730.78)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8232",
    transform: "translate(1111.84 513.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8606",
    d: "M501.828,859.17l37.058-64.2,37.058-64.179H427.69l37.058,64.179,37.058,64.2h0Z",
    transform: "translate(-427.69 -730.79)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8233",
    transform: "translate(74.138 513.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8607",
    d: "M79.343,794.982l37.058-64.2H-31.83l37.058,64.2,37.058,64.2Z",
    transform: "translate(31.83 -730.78)",
    fill: "#56aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8234",
    transform: "translate(222.391 513.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8608",
    d: "M107.935,859.183l37.058-64.2,37.058-64.2H33.82l37.058,64.179,37.058,64.2h0Z",
    transform: "translate(-33.82 -730.78)",
    fill: "#56aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8235",
    transform: "translate(370.621 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8609",
    d: "M173.575,673.93l-37.058,64.2-37.058,64.2H247.713l-37.058-64.2L173.6,673.93h0Z",
    transform: "translate(-99.46 -673.93)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8236",
    transform: "translate(222.391 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8610",
    d: "M107.935,673.93l-37.058,64.2-37.058,64.2H182.073l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-33.82 -673.93)",
    fill: "#56aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8237",
    transform: "translate(74.138 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8611",
    d: "M5.228,738.131l-37.058,64.2H116.4l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(31.83 -673.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8238",
    transform: "translate(1111.862 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8612",
    d: "M501.815,673.93l-37.057,64.2-37.058,64.2H575.953l-37.057-64.2-37.08-64.2Z",
    transform: "translate(-427.7 -673.93)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8239",
    transform: "translate(963.609 385.164)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8613",
    d: "M399.108,738.131l-37.058,64.2H510.3l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-362.05 -673.93)",
    fill: "#56aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8240",
    transform: "translate(815.357 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8614",
    d: "M370.515,673.93l-37.058,64.2-37.058,64.2H444.653l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-296.4 -673.93)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8241",
    transform: "translate(667.126 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8615",
    d: "M267.818,738.131l-37.058,64.2H379.013l-37.058-64.2L304.9,673.93l-37.058,64.2Z",
    transform: "translate(-230.76 -673.93)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8242",
    transform: "translate(296.506 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8616",
    d: "M177.835,738.131l37.058-64.2H66.64l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-66.64 -673.93)",
    fill: "#56aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8243",
    transform: "translate(444.736 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8617",
    d: "M206.418,802.333l37.058-64.2,37.058-64.2H132.28l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-132.28 -673.93)",
    fill: "#56aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8244",
    transform: "translate(592.989 385.164)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8618",
    d: "M309.125,738.131l37.058-64.2H197.93l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-197.93 -673.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8245",
    transform: "translate(741.219 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8619",
    d: "M374.765,738.131l37.058-64.2H263.57l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-263.57 -673.93)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8246",
    transform: "translate(889.472 385.164)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8620",
    d: "M403.358,802.333l37.058-64.2,37.058-64.2H329.22l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-329.22 -673.93)",
    fill: "#008843"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8247",
    transform: "translate(1037.702 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8621",
    d: "M469,802.333l37.058-64.2,37.058-64.2H394.86l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-394.86 -673.93)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8248",
    transform: "translate(0 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8622",
    d: "M46.535,738.131l37.058-64.2H-64.66l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(64.66 -673.93)",
    fill: "#56aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8249",
    transform: "translate(148.253 385.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8623",
    d: "M75.105,802.333l37.058-64.2,37.058-64.2H.99l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-0.99 -673.93)",
    fill: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8250",
    transform: "translate(592.989 256.783)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8624",
    d: "M272.045,617.08l-37.058,64.2-37.058,64.2H346.183l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-197.93 -617.08)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8251",
    transform: "translate(444.758 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8625",
    d: "M206.405,617.08l-37.058,64.2-37.058,64.2H280.543l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-132.29 -617.08)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8252",
    transform: "translate(296.506 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8626",
    d: "M140.755,617.08l-37.058,64.2-37.058,64.2H214.893l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-66.64 -617.08)",
    fill: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8253",
    transform: "translate(148.253 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8627",
    d: "M75.105,617.08l-37.058,64.2L.99,745.483H149.243L112.185,681.3,75.128,617.1h0Z",
    transform: "translate(-0.99 -617.08)",
    fill: "#56aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8254",
    transform: "translate(0.023 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8628",
    d: "M9.465,617.08l-37.058,64.2-37.058,64.2H83.58l-37.058-64.2L9.465,617.08Z",
    transform: "translate(64.65 -617.08)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8255",
    transform: "translate(1185.977 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8629",
    d: "M534.635,617.08l-37.058,64.2-37.058,64.2H608.773l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-460.52 -617.08)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8256",
    transform: "translate(1037.725 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8630",
    d: "M468.985,617.08l-37.058,64.2-37.058,64.2H543.123l-37.057-64.2-37.058-64.2h0Z",
    transform: "translate(-394.87 -617.08)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8257",
    transform: "translate(889.472 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8631",
    d: "M366.278,681.281l-37.058,64.2H477.473l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-329.22 -617.08)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8258",
    transform: "translate(741.242 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8632",
    d: "M337.7,617.08l-37.058,64.2-37.058,64.2H411.833l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-263.58 -617.08)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8259",
    transform: "translate(370.621 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8633",
    d: "M210.655,681.281l37.058-64.2H99.46l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-99.46 -617.08)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8260",
    transform: "translate(518.851 256.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8634",
    d: "M239.238,745.473l37.058-64.2,37.058-64.2H165.1l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-165.1 -617.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8261",
    transform: "translate(667.104 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8635",
    d: "M341.945,681.281,379,617.08H230.75l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-230.75 -617.08)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8262",
    transform: "translate(815.334 256.761)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8636",
    d: "M370.528,745.473l37.058-64.2,37.058-64.2H296.39l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-296.39 -617.07)",
    fill: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8263",
    transform: "translate(963.587 256.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8637",
    d: "M436.178,745.473l37.058-64.2,37.058-64.2H362.04l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-362.04 -617.07)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8264",
    transform: "translate(1111.84 256.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8638",
    d: "M501.828,745.473l37.058-64.2,37.058-64.2H427.69l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-427.69 -617.07)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8266",
    transform: "translate(74.138 256.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8640",
    d: "M79.343,681.281l37.058-64.2H-31.83l37.058,64.2,37.058,64.2Z",
    transform: "translate(31.83 -617.08)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8267",
    transform: "translate(222.391 256.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8641",
    d: "M107.935,745.473l37.058-64.2,37.058-64.2H33.82l37.058,64.2,37.058,64.2Z",
    transform: "translate(-33.82 -617.07)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8268",
    transform: "translate(518.874 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8642",
    d: "M202.168,624.421l-37.058,64.2H313.363l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-165.11 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8269",
    transform: "translate(370.621 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8643",
    d: "M136.518,624.421l-37.058,64.2H247.713l-37.058-64.2L173.6,560.22l-37.058,64.2Z",
    transform: "translate(-99.46 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8270",
    transform: "translate(222.391 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8644",
    d: "M70.878,624.421l-37.058,64.2H182.073l-37.058-64.2-37.058-64.2L70.9,624.421Z",
    transform: "translate(-33.82 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8271",
    transform: "translate(74.138 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8645",
    d: "M5.228,624.421l-37.058,64.2H116.4l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(31.83 -560.22)",
    fill: "#008843"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8273",
    transform: "translate(1111.84 128.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8647",
    d: "M464.747,624.419l-37.058,64.2H575.943l-37.058-64.179-37.08-64.2-37.058,64.2Z",
    transform: "translate(-427.69 -560.24)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8274",
    transform: "translate(963.609 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8648",
    d: "M399.108,624.421l-37.058,64.2H510.3l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-362.05 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8275",
    transform: "translate(815.357 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8649",
    d: "M333.458,624.421l-37.058,64.2H444.653l-37.058-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-296.4 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8276",
    transform: "translate(667.126 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8650",
    d: "M267.818,624.421l-37.058,64.2H379.013l-37.058-64.2L304.9,560.22l-37.058,64.2Z",
    transform: "translate(-230.76 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8277",
    transform: "translate(296.506 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8651",
    d: "M177.835,624.421l37.058-64.2H66.64l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-66.64 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8278",
    transform: "translate(444.736 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8652",
    d: "M206.418,688.623l37.058-64.2,37.058-64.2H132.28l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-132.28 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8279",
    transform: "translate(592.989 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8653",
    d: "M309.125,624.421l37.058-64.2H197.93l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-197.93 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8280",
    transform: "translate(741.219 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8654",
    d: "M374.765,624.421l37.058-64.2H263.57l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-263.57 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8281",
    transform: "translate(889.472 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8655",
    d: "M403.358,688.623l37.058-64.2,37.058-64.2H329.22l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-329.22 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8282",
    transform: "translate(1037.702 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8656",
    d: "M469,688.623l37.058-64.2,37.058-64.2H394.86l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-394.86 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8283",
    transform: "translate(0 128.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8657",
    d: "M9.478,688.623l37.058-64.2,37.058-64.2H-64.66l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(64.66 -560.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8284",
    transform: "translate(148.253 128.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8658",
    d: "M75.105,688.483l37.058-64.2,37.058-64.2H.99l37.058,64.179,37.058,64.2h0Z",
    transform: "translate(-0.99 -560.08)",
    fill: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8285",
    transform: "translate(592.989 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8659",
    d: "M272.045,503.38l-37.058,64.2-37.058,64.2H346.183l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-197.93 -503.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8286",
    transform: "translate(444.758 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8660",
    d: "M206.405,503.38l-37.058,64.2-37.058,64.2H280.543l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-132.29 -503.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8287",
    transform: "translate(296.506 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8661",
    d: "M140.755,503.38l-37.058,64.2-37.058,64.2H214.893l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-66.64 -503.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8288",
    transform: "translate(148.275 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8662",
    d: "M75.115,503.38l-37.058,64.2L1,631.76H149.253L112.2,567.582l-37.058-64.2h0Z",
    transform: "translate(-1 -503.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8289",
    transform: "translate(0.023 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8663",
    d: "M9.465,503.38l-37.058,64.2-37.058,64.2H83.58l-37.058-64.2L9.465,503.38Z",
    transform: "translate(64.65 -503.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8290",
    transform: "translate(1185.977 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8664",
    d: "M497.578,567.582l-37.058,64.2H608.773l-37.058-64.2-37.058-64.2-37.057,64.2Z",
    transform: "translate(-460.52 -503.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8291",
    transform: "translate(1037.725 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8665",
    d: "M431.928,567.582l-37.058,64.2H543.123l-37.057-64.2-37.058-64.2-37.058,64.2Z",
    transform: "translate(-394.87 -503.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8292",
    transform: "translate(889.494 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8666",
    d: "M403.345,503.38l-37.058,64.2-37.058,64.2H477.483l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-329.23 -503.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8293",
    transform: "translate(741.242 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8667",
    d: "M337.7,503.38l-37.058,64.2-37.058,64.2H411.833l-37.058-64.2-37.058-64.2h0Z",
    transform: "translate(-263.58 -503.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8294",
    transform: "translate(370.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8668",
    d: "M210.655,567.571l37.058-64.2H99.46l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-99.46 -503.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8295",
    transform: "translate(518.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8669",
    d: "M239.238,631.773l37.058-64.2,37.058-64.2H165.1l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-165.1 -503.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8296",
    transform: "translate(667.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8670",
    d: "M341.945,567.571,379,503.37H230.75l37.058,64.2,37.058,64.2,37.058-64.2Z",
    transform: "translate(-230.75 -503.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8297",
    transform: "translate(815.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8671",
    d: "M370.528,631.773l37.058-64.2,37.058-64.2H296.39l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-296.39 -503.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8298",
    transform: "translate(963.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8672",
    d: "M436.178,631.773l37.058-64.2,37.058-64.2H362.04l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-362.04 -503.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8299",
    transform: "translate(1111.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8673",
    d: "M501.828,631.773l37.058-64.2,37.058-64.2H427.69l37.058,64.2,37.058,64.2h0Z",
    transform: "translate(-427.69 -503.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8301",
    transform: "translate(74.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8675",
    d: "M79.343,567.571l37.058-64.2H-31.83l37.058,64.2,37.058,64.2Z",
    transform: "translate(31.83 -503.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8302",
    transform: "translate(222.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8676",
    d: "M107.935,631.773l37.058-64.2,37.058-64.2H33.82l37.058,64.2,37.058,64.2Z",
    transform: "translate(-33.82 -503.37)",
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "INVOICE",
    transform: "translate(1092.916 152.097)",
    fill: "#3c3c3b",
    fontSize: 51,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INVOICE")), /*#__PURE__*/React.createElement("text", {
    id: "DUE",
    transform: "translate(1183.448 195.861)",
    fill: "#f3a50d",
    fontSize: 51,
    fontFamily: "myriad-pro",
    fontWeight: 600,
    textDecoration: "underline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DUE")), /*#__PURE__*/React.createElement("path", {
    id: "Path_38506",
    "data-name": "Path 38506",
    d: "M41.421,258.81h1188.1a12.582,12.582,0,0,1,12.578,12.578v57.833H28.82V271.388A12.582,12.582,0,0,1,41.4,258.81Z",
    transform: "translate(36.262 326.851)",
    fill: "#56aa46",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38507",
    "data-name": "Path 38507",
    d: "M8.988,0H281.737a9.021,9.021,0,0,1,9.01,9.01V70.434H0V9.01A9.021,9.021,0,0,1,9.01,0Z",
    transform: "translate(1280.259 1234.653) rotate(180)",
    fill: "#56aa46",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31626",
    "data-name": "Rectangle 31626",
    width: 1344.28,
    height: 19.195,
    transform: "translate(0 1.208)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12184",
    transform: "translate(71.812 104.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11637",
    d: "M71.21,46.9a71.778,71.778,0,0,1,12.059-.948c6.21,0,10.772,1.423,13.662,4.02A13.069,13.069,0,0,1,101.2,60.132c0,4.4-1.287,7.881-3.726,10.41-3.32,3.545-8.717,5.352-14.859,5.375a21.187,21.187,0,0,1-5.058-.429V94.977H71.3L71.21,46.9Zm6.323,23.463a21.22,21.22,0,0,0,5.194.5c7.588,0,12.194-3.7,12.194-10.41,0-6.436-4.562-9.53-11.494-9.507a25.992,25.992,0,0,0-5.917.519V70.385Z",
    transform: "translate(17.787 -45.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11638",
    d: "M108.231,87.514l-.519-4.4h-.226A12.962,12.962,0,0,1,96.8,88.327c-7.068,0-10.681-4.968-10.7-10.027,0-8.446,7.5-13.075,20.979-13.03v-.723c0-2.891-.813-8.084-7.949-8.062a17.327,17.327,0,0,0-9.1,2.62l-1.445-4.178a21.394,21.394,0,0,1,11.472-3.116c10.681,0,13.3,7.272,13.3,14.272V79.159a54.836,54.836,0,0,0,.61,8.378h-5.781ZM107.26,69.7c-6.933-.135-14.791,1.107-14.791,7.9,0,4.11,2.755,6.052,6.007,6.052a8.714,8.714,0,0,0,8.446-5.871,6.868,6.868,0,0,0,.361-2.032V69.674Z",
    transform: "translate(36.522 -38.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11639",
    d: "M108.248,52.155l4.991,7.5c1.31,1.942,2.394,3.749,3.545,5.691h.226c1.152-2.1,2.3-3.907,3.455-5.781l4.9-7.452h6.865L120.352,69.024l12.307,18.021h-7.226l-5.149-7.836c-1.378-2.01-2.529-3.974-3.771-6.052h-.135c-1.152,2.1-2.371,3.974-3.681,6.075l-5.036,7.881h-7l12.4-17.84L101.179,52.178h7.068Z",
    transform: "translate(54.842 -38.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11640",
    d: "M127.765,47.673V57.7h9.123v4.833h-9.1V81.365c.045,4.336,1.265,6.775,4.81,6.775a15.477,15.477,0,0,0,3.681-.429l.294,4.765a15.931,15.931,0,0,1-5.623.881,8.775,8.775,0,0,1-6.865-2.665c-1.807-1.874-2.461-4.991-2.461-9.1V62.532H116.18V57.7h5.4V49.321l6.188-1.671Z",
    transform: "translate(74.369 -43.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11641",
    d: "M161.364,69.683c0,12.917-8.92,18.563-17.366,18.585-9.462,0-16.756-6.91-16.779-17.953,0-11.7,7.61-18.563,17.3-18.585,10.027,0,16.824,7.272,16.846,17.953m-27.731.406c0,7.655,4.426,13.414,10.636,13.414,6.075,0,10.614-5.713,10.591-13.595,0-5.917-2.981-13.414-10.5-13.414s-10.749,6.955-10.727,13.595",
    transform: "translate(88.26 -38.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11642",
    d: "M146.044,61.99c0-3.613-.09-6.571-.294-9.462h5.623l.361,5.758h.135a12.856,12.856,0,0,1,11.54-6.594c4.833,0,12.353,2.868,12.375,14.859l.045,20.866h-6.346L169.439,67.3c0-5.623-2.1-10.32-8.107-10.32a9.04,9.04,0,0,0-8.514,6.5,9.387,9.387,0,0,0-.429,2.958l.045,21h-6.346l-.045-25.473Z",
    transform: "translate(111.575 -38.729)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "my",
    transform: "translate(0 17.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12702",
    "data-name": "Group 12702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38508",
    "data-name": "Path 38508",
    d: "M32.094,62.643c0-3.162-.135-5.533-.294-8.243h3.162l.294,6.1h.135c2.145-3.952,5.442-6.888,11.11-6.888a10.352,10.352,0,0,1,9.891,7.542h.135a13.509,13.509,0,0,1,3.523-4.675,11.724,11.724,0,0,1,8.243-2.868c3.365,0,11.2,1.874,11.2,14.927v20.3H76.129V68.9c0-7.746-3-12.353-8.965-12.353-4.313,0-7.746,3.162-9.033,6.82a10.02,10.02,0,0,0-.655,3.365V88.838H54.111V67.317c0-6.233-3-10.772-8.536-10.772-4.675,0-8.243,3.726-9.552,7.746a9.522,9.522,0,0,0-.565,3.3v21.25H32.094v-26.2Z",
    transform: "translate(-31.8 -53.61)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38509",
    "data-name": "Path 38509",
    d: "M59.093,53.973,68.126,76.51c.926,2.439,1.874,5.171,2.507,7.384h.135c.723-2.145,1.581-4.81,2.665-7.61l8.4-22.311h3.658L75.15,79.649c-4.155,10.681-7.113,17.072-11.63,21.024a19.848,19.848,0,0,1-6.029,3.591L56.406,101.4a17.5,17.5,0,0,0,6.029-3.884,26.04,26.04,0,0,0,5.736-8.6,4.744,4.744,0,0,0,.429-1.513,4.335,4.335,0,0,0-.429-1.513L55.39,53.95h3.658Z",
    transform: "translate(-2.118 -53.182)",
    fill: "#56aa1c"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31627",
    "data-name": "Rectangle 31627",
    width: 1344.28,
    height: 19.195,
    transform: "translate(0 1883.194)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31628",
    "data-name": "Rectangle 31628",
    width: 1213.28,
    height: 111.963,
    transform: "translate(65.082 879.998)",
    fill: "#f1f1f2",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31629",
    "data-name": "Rectangle 31629",
    width: 1213.28,
    height: 111.963,
    transform: "translate(65.082 656.072)",
    fill: "#f1f1f2",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1_of_1",
    "data-name": "1 of 1",
    transform: "translate(1238.029 1836.983)",
    fill: "#56aa1c",
    fontSize: 17,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    xmlSpace: "preserve",
    fontFamily: "myriad-pro",
    fontWeight: 400
  }, " of "), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "Invoice_No:",
    "data-name": "Invoice No:",
    transform: "translate(861.492 341.528)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "voice No:")), /*#__PURE__*/React.createElement("text", {
    id: "Customer_VAT_number:",
    "data-name": "Customer VAT number:",
    transform: "translate(861.492 375.447)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.01em"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ustomer "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.06em"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.08em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "T number:")), /*#__PURE__*/React.createElement("text", {
    id: "Invoice_date:",
    "data-name": "Invoice date:",
    transform: "translate(861.492 409.389)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "voice date:")), /*#__PURE__*/React.createElement("text", {
    id: "Account_reference:",
    "data-name": "Account reference:",
    transform: "translate(861.492 443.307)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.01em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ccount re"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ence:")), /*#__PURE__*/React.createElement("text", {
    id: "INVOICE_TO",
    "data-name": "INVOICE TO",
    transform: "translate(65.082 327.221)",
    fill: "#56aa1c",
    fontSize: 26,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INVOICE "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.03em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "TOTAL",
    transform: "translate(1017.13 1202.637)",
    fill: "#404041",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.03em"
  }, "TO"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.07em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "AL")), /*#__PURE__*/React.createElement("text", {
    id: "DESCRIPTION",
    transform: "translate(94.484 626.427)",
    fill: "#404041",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DESCRIPTION")), /*#__PURE__*/React.createElement("text", {
    id: "QUANTITY",
    transform: "translate(745.126 626.427)",
    fill: "#404041",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.03em"
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ANTI"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.02em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "UNIT_PRICE_GBP_",
    "data-name": "UNIT PRICE (GBP)",
    transform: "translate(932.491 626.427)",
    fill: "#404041",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "UNIT PRICE (GBP)")), /*#__PURE__*/React.createElement("text", {
    id: "TOTAL_GBP_",
    "data-name": "TOTAL (GBP)",
    transform: "translate(1143.794 626.427)",
    fill: "#404041",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.03em"
  }, "TO"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.07em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "AL (GBP)")), /*#__PURE__*/React.createElement("text", {
    id: "Currency",
    transform: "translate(1013.562 1141.259)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.01em"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ur"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "en"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.02em"
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "y")), /*#__PURE__*/React.createElement("text", {
    id: "VAT_0_",
    "data-name": "VAT @ 0%",
    transform: "translate(1013.562 1104.743)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.06em"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.08em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "T @ 0%")), /*#__PURE__*/React.createElement("text", {
    id: "Sub_total",
    "data-name": "Sub total",
    transform: "translate(1013.562 1068.069)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sub total")), /*#__PURE__*/React.createElement("text", {
    id: "Company_Name",
    "data-name": "Company Name",
    transform: "translate(65.082 373.866)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Company Name")), /*#__PURE__*/React.createElement("text", {
    id: "Company_address_1",
    "data-name": "Company address 1",
    transform: "translate(65.082 407.808)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Company address 1")), /*#__PURE__*/React.createElement("text", {
    id: "GBP",
    transform: "translate(1217.887 1140.259)",
    fill: "#3c3c3b",
    fontSize: 19,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GBP")), /*#__PURE__*/React.createElement("text", {
    id: "_0.00",
    "data-name": 0,
    transform: "translate(1217.367 1104.743)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0.00")), /*#__PURE__*/React.createElement("text", {
    id: "_25",
    "data-name": 25,
    transform: "translate(745.78 953.999)",
    fill: "#3c3c3b",
    fontSize: 19,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25")), /*#__PURE__*/React.createElement("text", {
    id: "_2.10",
    "data-name": "\\xA32.10",
    transform: "translate(933.914 954.999)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA32.10")), /*#__PURE__*/React.createElement("text", {
    id: "_52.50",
    "data-name": "\\xA352.50",
    transform: "translate(1193.588 954.999)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA352.50")), /*#__PURE__*/React.createElement("text", {
    id: "Entry_App_users",
    "data-name": "Entry App users",
    transform: "translate(145.724 954.999)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ent"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.03em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "y App users")), /*#__PURE__*/React.createElement("text", {
    id: "Moulsecoomb_House",
    "data-name": "Moulsecoomb House",
    transform: "translate(95.93 913.313)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Moulsecoomb House")), /*#__PURE__*/React.createElement("text", {
    id: "_20",
    "data-name": 20,
    transform: "translate(745.78 841.991)",
    fill: "#3c3c3b",
    fontSize: 19,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("text", {
    id: "_2.10-2",
    "data-name": "\\xA32.10",
    transform: "translate(933.914 842.991)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA32.10")), /*#__PURE__*/React.createElement("text", {
    id: "_42.00",
    "data-name": "\\xA342.00",
    transform: "translate(1193.588 842.991)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA342.00")), /*#__PURE__*/React.createElement("text", {
    id: "Entry_App_users-2",
    "data-name": "Entry App users",
    transform: "translate(145.724 842.991)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ent"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.03em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "y App users")), /*#__PURE__*/React.createElement("text", {
    id: "Brampton_Road",
    "data-name": "Brampton Road",
    transform: "translate(95.93 801.305)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Brampton Road")), /*#__PURE__*/React.createElement("text", {
    id: "_178.50",
    "data-name": "\\xA3178.50",
    transform: "translate(1186.067 1068.069)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA3178.50")), /*#__PURE__*/React.createElement("text", {
    id: "_40",
    "data-name": 40,
    transform: "translate(745.78 730.051)",
    fill: "#3c3c3b",
    fontSize: 19,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "40")), /*#__PURE__*/React.createElement("text", {
    id: "_2.10-3",
    "data-name": "\\xA32.10",
    transform: "translate(933.914 731.051)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA32.10")), /*#__PURE__*/React.createElement("text", {
    id: "_84.00",
    "data-name": "\\xA384.00",
    transform: "translate(1193.588 731.051)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA384.00")), /*#__PURE__*/React.createElement("text", {
    id: "Entry_App_users-3",
    "data-name": "Entry App users",
    transform: "translate(145.724 731.051)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ent"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.03em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "y App users")), /*#__PURE__*/React.createElement("text", {
    id: "Student_Castle",
    "data-name": "Student Castle",
    transform: "translate(95.93 689.364)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Student Castle")), /*#__PURE__*/React.createElement("text", {
    id: "_335218",
    "data-name": 335218,
    transform: "translate(1217.705 341.528)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "335218")), /*#__PURE__*/React.createElement("text", {
    id: "_12334523",
    "data-name": 12334523,
    transform: "translate(1195.575 375.447)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "12334523")), /*#__PURE__*/React.createElement("text", {
    id: "_01_July_2022",
    "data-name": "01 July 2022",
    transform: "translate(1175.996 409.389)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "01 July 2022")), /*#__PURE__*/React.createElement("text", {
    id: "Company_reference",
    "data-name": "Company reference",
    transform: "translate(1113.916 443.307)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Company reference")), /*#__PURE__*/React.createElement("text", {
    id: "_01_July_2022-2",
    "data-name": "01 July 2022",
    transform: "translate(1175.996 409.389)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "01 July 2022")), /*#__PURE__*/React.createElement("text", {
    id: "Address_line_2",
    "data-name": "Address line 2",
    transform: "translate(65.082 441.727)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Address line 2")), /*#__PURE__*/React.createElement("text", {
    id: "Address_3",
    "data-name": "Address 3",
    transform: "translate(65.082 475.667)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Address 3")), /*#__PURE__*/React.createElement("text", {
    id: "_178.50-2",
    "data-name": "\\xA3178.50",
    transform: "translate(1182.681 1202.637)",
    fill: "#404041",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA3178.50")), /*#__PURE__*/React.createElement("g", {
    id: "Group_12703",
    "data-name": "Group 12703",
    transform: "translate(318.252 1715.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38510",
    "data-name": "Path 38510",
    d: "M140.93,759.761a21.091,21.091,0,0,1,3.387-.271,5.684,5.684,0,0,1,3.839,1.129,3.716,3.716,0,0,1,1.2,2.868,4.071,4.071,0,0,1-1.061,2.936,5.671,5.671,0,0,1-4.178,1.513,5.6,5.6,0,0,1-1.423-.113v5.488H140.93V759.761Zm1.761,6.617a6.623,6.623,0,0,0,1.468.135c2.145,0,3.433-1.039,3.433-2.936s-1.287-2.687-3.229-2.687a8.672,8.672,0,0,0-1.671.135v5.329Z",
    transform: "translate(-140.93 -758.858)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38511",
    "data-name": "Path 38511",
    d: "M151.33,771.222l-.135-1.242h-.068a3.663,3.663,0,0,1-3,1.468,2.8,2.8,0,0,1-3-2.823c0-2.371,2.123-3.681,5.917-3.658v-.2a2.032,2.032,0,0,0-2.236-2.281,4.964,4.964,0,0,0-2.552.723l-.406-1.174a6.175,6.175,0,0,1,3.229-.881c3,0,3.749,2.055,3.749,4.02v3.681a14.587,14.587,0,0,0,.158,2.349h-1.626Zm-.271-5.013c-1.942-.045-4.178.294-4.178,2.213a1.593,1.593,0,0,0,1.694,1.716,2.418,2.418,0,0,0,2.371-1.648,1.641,1.641,0,0,0,.09-.565v-1.716Z",
    transform: "translate(-135.658 -756.769)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38512",
    "data-name": "Path 38512",
    d: "M151.38,761.25l1.4,2.123c.361.542.677,1.061.994,1.6h.068c.316-.587.655-1.107.971-1.626l1.378-2.1h1.919l-3.365,4.765L158.2,771.1h-2.032l-1.445-2.213c-.384-.565-.723-1.129-1.061-1.716h-.045c-.316.587-.677,1.129-1.039,1.716l-1.423,2.213H149.19l3.5-5.013-3.342-4.81h1.987Z",
    transform: "translate(-130.537 -756.643)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38513",
    "data-name": "Path 38513",
    d: "M156.854,760v2.823h2.552v1.355h-2.552v5.307c0,1.219.339,1.919,1.332,1.919a4.942,4.942,0,0,0,1.039-.113l.09,1.332a4.515,4.515,0,0,1-1.581.248,2.463,2.463,0,0,1-1.92-.745,3.56,3.56,0,0,1-.7-2.552V764.2H153.58v-1.355h1.536V760.5l1.739-.474Z",
    transform: "translate(-125.013 -758.216)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38514",
    "data-name": "Path 38514",
    d: "M166.3,766.218c0,3.636-2.529,5.216-4.9,5.216-2.665,0-4.72-1.942-4.72-5.058,0-3.3,2.145-5.217,4.878-5.217a4.715,4.715,0,0,1,4.742,5.058Zm-7.813.09c0,2.145,1.242,3.771,2.981,3.771s2.981-1.6,2.981-3.816c0-1.671-.836-3.771-2.958-3.771s-3.026,1.942-3.026,3.816Z",
    transform: "translate(-121.113 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38515",
    "data-name": "Path 38515",
    d: "M161.99,764.041a24.338,24.338,0,0,0-.09-2.665h1.581l.09,1.626h.045a3.647,3.647,0,0,1,3.252-1.852c1.355,0,3.478.813,3.478,4.2v5.871h-1.784v-5.668c0-1.581-.587-2.913-2.281-2.913a2.532,2.532,0,0,0-2.394,1.829,2.34,2.34,0,0,0-.113.836v5.917H161.99V764.04Z",
    transform: "translate(-114.545 -756.769)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38516",
    "data-name": "Path 38516",
    d: "M171.662,768.934l-1.423,4.313H168.41l4.652-13.708h2.145l4.675,13.708h-1.9l-1.468-4.313h-4.855Zm4.494-1.377-1.332-3.952c-.316-.9-.519-1.716-.723-2.507h-.045c-.2.813-.429,1.648-.7,2.484l-1.332,3.974Z",
    transform: "translate(-106.354 -758.795)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38517",
    "data-name": "Path 38517",
    d: "M181.653,770.835a6.589,6.589,0,0,1-2.823.565,4.677,4.677,0,0,1-4.9-5.013,5.009,5.009,0,0,1,5.284-5.217,6.359,6.359,0,0,1,2.484.5l-.406,1.377a4.129,4.129,0,0,0-2.078-.474,3.409,3.409,0,0,0-3.478,3.726,3.374,3.374,0,0,0,3.41,3.681,4.969,4.969,0,0,0,2.19-.5l.316,1.332Z",
    transform: "translate(-99.408 -756.744)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38518",
    "data-name": "Path 38518",
    d: "M185.633,770.835a6.589,6.589,0,0,1-2.823.565,4.677,4.677,0,0,1-4.9-5.013,5.009,5.009,0,0,1,5.284-5.217,6.358,6.358,0,0,1,2.484.5l-.406,1.377a4.128,4.128,0,0,0-2.078-.474,3.409,3.409,0,0,0-3.478,3.726,3.374,3.374,0,0,0,3.41,3.681,4.969,4.969,0,0,0,2.19-.5l.316,1.332Z",
    transform: "translate(-94.401 -756.744)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38519",
    "data-name": "Path 38519",
    d: "M183.6,766.625a3.147,3.147,0,0,0,3.365,3.41,6.765,6.765,0,0,0,2.732-.5l.294,1.287a7.864,7.864,0,0,1-3.274.61c-3.026,0-4.833-1.987-4.833-4.968s1.739-5.307,4.607-5.307c3.207,0,4.065,2.823,4.065,4.629a6.159,6.159,0,0,1-.068.835h-6.91Zm5.239-1.287c0-1.129-.474-2.913-2.484-2.913-1.807,0-2.6,1.671-2.755,2.913h5.217Z",
    transform: "translate(-89.405 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38520",
    "data-name": "Path 38520",
    d: "M186.852,769.38a4.736,4.736,0,0,0,2.349.723c1.31,0,1.919-.655,1.919-1.468s-.519-1.31-1.829-1.807c-1.761-.632-2.6-1.6-2.6-2.778,0-1.581,1.287-2.891,3.387-2.891a4.985,4.985,0,0,1,2.416.61l-.452,1.31a3.809,3.809,0,0,0-2.01-.565c-1.061,0-1.648.61-1.648,1.332,0,.813.587,1.174,1.874,1.671,1.716.655,2.574,1.513,2.574,2.958,0,1.739-1.332,2.958-3.681,2.958a5.517,5.517,0,0,1-2.755-.677l.452-1.355Z",
    transform: "translate(-83.718 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38521",
    "data-name": "Path 38521",
    d: "M190.422,769.38a4.735,4.735,0,0,0,2.349.723c1.31,0,1.919-.655,1.919-1.468s-.519-1.31-1.829-1.807c-1.761-.632-2.6-1.6-2.6-2.778,0-1.581,1.287-2.891,3.387-2.891a4.985,4.985,0,0,1,2.416.61l-.452,1.31a3.809,3.809,0,0,0-2.01-.565c-1.061,0-1.648.61-1.648,1.332,0,.813.587,1.174,1.874,1.671,1.716.655,2.574,1.513,2.574,2.958,0,1.739-1.332,2.958-3.681,2.958a5.517,5.517,0,0,1-2.755-.677l.452-1.355Z",
    transform: "translate(-79.226 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38522",
    "data-name": "Path 38522",
    d: "M195.783,759.54h1.761v12.217h5.849v1.49H195.76V759.54Z",
    transform: "translate(-71.941 -758.795)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38523",
    "data-name": "Path 38523",
    d: "M202.734,760v2.823h2.552v1.355h-2.552v5.307c0,1.219.339,1.919,1.332,1.919a4.942,4.942,0,0,0,1.039-.113l.09,1.332a4.515,4.515,0,0,1-1.581.248,2.463,2.463,0,0,1-1.919-.745,3.56,3.56,0,0,1-.7-2.552V764.2H199.46v-1.355H201V760.5l1.739-.474Z",
    transform: "translate(-67.286 -758.216)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38524",
    "data-name": "Path 38524",
    d: "M211.784,759.22v11.9a22.241,22.241,0,0,0,.09,2.552h-1.6l-.09-1.716h-.045a3.619,3.619,0,0,1-3.365,1.942c-2.371,0-4.2-2.01-4.2-4.991,0-3.274,2.01-5.284,4.4-5.284a3.249,3.249,0,0,1,2.958,1.513h.045v-5.871h1.784Zm-1.784,8.6a2.111,2.111,0,0,0-.09-.745A2.649,2.649,0,0,0,207.335,765c-1.852,0-2.958,1.626-2.958,3.794,0,1.987.971,3.636,2.913,3.636a2.677,2.677,0,0,0,2.62-2.145,2.862,2.862,0,0,0,.09-.768V767.8Z",
    transform: "translate(-63.373 -759.197)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38525",
    "data-name": "Path 38525",
    d: "M207.36,769.538a29.333,29.333,0,0,0,1.219-4.855l1.987-.2a25.739,25.739,0,0,1-1.92,4.946l-1.287.113Z",
    transform: "translate(-57.346 -752.579)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38526",
    "data-name": "Path 38526",
    d: "M211.67,759.761a21.092,21.092,0,0,1,3.387-.271,5.684,5.684,0,0,1,3.839,1.129,3.716,3.716,0,0,1,1.2,2.868,4.071,4.071,0,0,1-1.061,2.936,5.671,5.671,0,0,1-4.178,1.513,5.6,5.6,0,0,1-1.423-.113v5.488H211.67V759.761Zm1.761,6.617a6.623,6.623,0,0,0,1.468.135c2.145,0,3.433-1.039,3.433-2.936s-1.287-2.687-3.229-2.687a8.672,8.672,0,0,0-1.671.135v5.329Z",
    transform: "translate(-51.923 -758.858)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38527",
    "data-name": "Path 38527",
    d: "M222.07,771.222l-.135-1.242h-.068a3.663,3.663,0,0,1-3,1.468,2.8,2.8,0,0,1-3-2.823c0-2.371,2.123-3.681,5.917-3.658v-.2a2.032,2.032,0,0,0-2.236-2.281,5.028,5.028,0,0,0-2.552.723l-.406-1.174a6.175,6.175,0,0,1,3.229-.881c3,0,3.749,2.055,3.749,4.02v3.681a14.588,14.588,0,0,0,.158,2.349h-1.626Zm-.271-5.013c-1.942-.045-4.178.294-4.178,2.213a1.593,1.593,0,0,0,1.694,1.716,2.418,2.418,0,0,0,2.371-1.648,1.675,1.675,0,0,0,.113-.565Z",
    transform: "translate(-46.651 -756.769)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38528",
    "data-name": "Path 38528",
    d: "M222.12,761.25l1.4,2.123c.361.542.677,1.061.994,1.6h.068c.316-.587.655-1.107.971-1.626l1.378-2.1h1.919l-3.365,4.765,3.455,5.081h-2.032l-1.445-2.213c-.384-.565-.7-1.129-1.061-1.716h-.045c-.316.587-.677,1.129-1.039,1.716l-1.423,2.213H219.93l3.5-5.013-3.342-4.81h1.987Z",
    transform: "translate(-41.53 -756.643)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38529",
    "data-name": "Path 38529",
    d: "M227.594,760v2.823h2.552v1.355h-2.552v5.307c0,1.219.339,1.919,1.332,1.919a4.942,4.942,0,0,0,1.039-.113l.09,1.332a4.516,4.516,0,0,1-1.581.248,2.463,2.463,0,0,1-1.919-.745,3.56,3.56,0,0,1-.7-2.552V764.2H224.32v-1.355h1.536V760.5l1.739-.474Z",
    transform: "translate(-36.006 -758.216)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38530",
    "data-name": "Path 38530",
    d: "M237.04,766.218c0,3.636-2.529,5.216-4.9,5.216-2.665,0-4.72-1.942-4.72-5.058,0-3.3,2.145-5.217,4.878-5.217A4.715,4.715,0,0,1,237.04,766.218Zm-7.814.09c0,2.145,1.242,3.771,2.981,3.771s2.981-1.6,2.981-3.816c0-1.671-.836-3.771-2.958-3.771s-3.026,1.942-3.026,3.816Z",
    transform: "translate(-32.106 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38531",
    "data-name": "Path 38531",
    d: "M232.73,764.041a24.33,24.33,0,0,0-.09-2.665h1.581l.113,1.626h.045a3.647,3.647,0,0,1,3.252-1.852c1.355,0,3.478.813,3.478,4.2v5.871h-1.784v-5.668c0-1.581-.587-2.913-2.281-2.913a2.532,2.532,0,0,0-2.394,1.829,2.342,2.342,0,0,0-.113.836v5.917h-1.784V764.04Z",
    transform: "translate(-25.538 -756.769)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38532",
    "data-name": "Path 38532",
    d: "M241.371,759.54v5.736h6.639V759.54h1.784v13.708h-1.784v-6.413h-6.639v6.413H239.61V759.54Z",
    transform: "translate(-16.768 -758.795)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38533",
    "data-name": "Path 38533",
    d: "M254.76,766.218c0,3.636-2.529,5.216-4.9,5.216-2.665,0-4.72-1.942-4.72-5.058,0-3.3,2.145-5.217,4.878-5.217a4.715,4.715,0,0,1,4.742,5.058Zm-7.813.09c0,2.145,1.242,3.771,2.981,3.771s2.981-1.6,2.981-3.816c0-1.671-.836-3.771-2.958-3.771s-3.026,1.942-3.026,3.816Z",
    transform: "translate(-9.81 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38534",
    "data-name": "Path 38534",
    d: "M258.645,768.409a24.342,24.342,0,0,0,.09,2.687h-1.581l-.09-1.6h-.045a3.727,3.727,0,0,1-3.252,1.829c-1.536,0-3.387-.858-3.387-4.313V761.25h1.784v5.442c0,1.874.565,3.139,2.19,3.139a2.568,2.568,0,0,0,2.349-1.626,2.942,2.942,0,0,0,.158-.926V761.25h1.784v7.158Z",
    transform: "translate(-3.217 -756.643)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38535",
    "data-name": "Path 38535",
    d: "M255.492,769.38a4.736,4.736,0,0,0,2.349.723c1.31,0,1.919-.655,1.919-1.468s-.519-1.31-1.829-1.807c-1.761-.632-2.6-1.6-2.6-2.778,0-1.581,1.287-2.891,3.387-2.891a4.986,4.986,0,0,1,2.416.61l-.452,1.31a3.809,3.809,0,0,0-2.01-.565c-1.061,0-1.648.61-1.648,1.332,0,.813.587,1.174,1.874,1.671,1.716.655,2.574,1.513,2.574,2.958,0,1.739-1.332,2.958-3.681,2.958a5.517,5.517,0,0,1-2.755-.677l.452-1.355Z",
    transform: "translate(2.647 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38536",
    "data-name": "Path 38536",
    d: "M260.316,766.625a3.146,3.146,0,0,0,3.365,3.41,6.765,6.765,0,0,0,2.732-.5l.294,1.287a7.865,7.865,0,0,1-3.274.61c-3.026,0-4.833-1.987-4.833-4.968s1.739-5.307,4.607-5.307c3.207,0,4.065,2.823,4.065,4.629a6.149,6.149,0,0,1-.068.835h-6.91Zm5.239-1.287c0-1.129-.474-2.913-2.484-2.913-1.807,0-2.6,1.671-2.755,2.913h5.216Z",
    transform: "translate(7.126 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38537",
    "data-name": "Path 38537",
    d: "M262.8,769.538a29.333,29.333,0,0,0,1.219-4.855l1.987-.2a25.739,25.739,0,0,1-1.92,4.946l-1.287.113Z",
    transform: "translate(12.411 -752.579)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38538",
    "data-name": "Path 38538",
    d: "M268.881,759.54v5.736h6.639V759.54H277.3v13.708h-1.784v-6.413h-6.639v6.413H267.12V759.54Z",
    transform: "translate(17.846 -758.795)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38539",
    "data-name": "Path 38539",
    d: "M282.26,766.218c0,3.636-2.529,5.216-4.9,5.216-2.665,0-4.72-1.942-4.72-5.058,0-3.3,2.145-5.217,4.878-5.217A4.715,4.715,0,0,1,282.26,766.218Zm-7.813.09c0,2.145,1.242,3.771,2.981,3.771s2.981-1.6,2.981-3.816c0-1.671-.836-3.771-2.958-3.771s-3.026,1.942-3.026,3.816Z",
    transform: "translate(24.792 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38540",
    "data-name": "Path 38540",
    d: "M277.95,764.053a24.314,24.314,0,0,0-.09-2.665h1.558l.09,1.581h.068a3.4,3.4,0,0,1,3.094-1.807,2.913,2.913,0,0,1,2.778,1.965h.045a4.485,4.485,0,0,1,1.107-1.287,3.329,3.329,0,0,1,2.168-.7c1.31,0,3.229.858,3.229,4.268v5.8h-1.739v-5.578c0-1.9-.7-3.026-2.145-3.026a2.33,2.33,0,0,0-2.123,1.626,2.716,2.716,0,0,0-.135.9v6.075h-1.739v-5.894c0-1.558-.7-2.71-2.055-2.71a2.452,2.452,0,0,0-2.213,1.784,2.256,2.256,0,0,0-.135.881v5.939h-1.739v-7.181Z",
    transform: "translate(31.36 -756.781)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38541",
    "data-name": "Path 38541",
    d: "M286.8,766.625a3.147,3.147,0,0,0,3.365,3.41,6.765,6.765,0,0,0,2.732-.5l.294,1.287a7.865,7.865,0,0,1-3.274.61c-3.026,0-4.833-1.987-4.833-4.968s1.739-5.307,4.607-5.307c3.207,0,4.065,2.823,4.065,4.629a6.149,6.149,0,0,1-.068.835h-6.91Zm5.239-1.287c0-1.129-.474-2.913-2.484-2.913-1.807,0-2.6,1.671-2.755,2.913h5.217Z",
    transform: "translate(40.444 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38542",
    "data-name": "Path 38542",
    d: "M291.85,759.54h7.384v1.49h-5.6v4.562h5.194v1.468h-5.194v6.21h-1.761V759.563Z",
    transform: "translate(48.962 -758.795)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38543",
    "data-name": "Path 38543",
    d: "M301.67,771.222l-.135-1.242h-.068a3.663,3.663,0,0,1-3,1.468,2.8,2.8,0,0,1-3-2.823c0-2.371,2.123-3.681,5.917-3.658v-.2a2.032,2.032,0,0,0-2.236-2.281,5.028,5.028,0,0,0-2.552.723l-.406-1.174a6.175,6.175,0,0,1,3.229-.881c3,0,3.749,2.055,3.749,4.02v3.681a14.581,14.581,0,0,0,.158,2.349h-1.626Zm-.271-5.013c-1.942-.045-4.178.294-4.178,2.213a1.593,1.593,0,0,0,1.694,1.716,2.418,2.418,0,0,0,2.371-1.648,1.675,1.675,0,0,0,.113-.565v-1.716Z",
    transform: "translate(53.504 -756.769)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38544",
    "data-name": "Path 38544",
    d: "M300.18,764.447c0-1.152,0-2.145-.09-3.071h1.558l.068,1.942h.09a2.967,2.967,0,0,1,2.732-2.168,1.155,1.155,0,0,1,.5.068v1.694a2.391,2.391,0,0,0-.61-.068,2.5,2.5,0,0,0-2.394,2.3,4.507,4.507,0,0,0-.09.836v5.239H300.18Z",
    transform: "translate(59.33 -756.769)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38545",
    "data-name": "Path 38545",
    d: "M303.16,764.053a24.33,24.33,0,0,0-.09-2.665h1.558l.09,1.581h.068a3.4,3.4,0,0,1,3.094-1.807,2.913,2.913,0,0,1,2.778,1.965h.045a4.165,4.165,0,0,1,1.107-1.287,3.329,3.329,0,0,1,2.168-.7c1.31,0,3.229.858,3.229,4.268v5.8h-1.739v-5.578c0-1.9-.7-3.026-2.145-3.026a2.33,2.33,0,0,0-2.123,1.626,2.716,2.716,0,0,0-.135.9v6.075h-1.739v-5.894c0-1.558-.7-2.71-2.055-2.71a2.428,2.428,0,0,0-2.213,1.784,2.769,2.769,0,0,0-.135.881v5.939h-1.739v-7.181Z",
    transform: "translate(63.08 -756.781)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38546",
    "data-name": "Path 38546",
    d: "M312.55,759.784a18.548,18.548,0,0,1,3.387-.294c1.9,0,3.116.339,3.974,1.129a3.368,3.368,0,0,1,1.084,2.6,3.6,3.6,0,0,1-2.574,3.5v.068a3.365,3.365,0,0,1,2.01,2.755,21.608,21.608,0,0,0,1.061,3.771h-1.829a18.738,18.738,0,0,1-.926-3.275c-.406-1.9-1.129-2.6-2.732-2.665h-1.671v5.939h-1.761V759.784Zm1.761,6.233h1.807c1.9,0,3.094-1.039,3.094-2.6,0-1.761-1.287-2.529-3.161-2.552a7.921,7.921,0,0,0-1.739.158Z",
    transform: "translate(75.008 -758.858)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38547",
    "data-name": "Path 38547",
    d: "M326.71,766.218c0,3.636-2.529,5.216-4.9,5.216-2.665,0-4.72-1.942-4.72-5.058,0-3.3,2.168-5.217,4.878-5.217A4.728,4.728,0,0,1,326.71,766.218Zm-7.813.09c0,2.145,1.242,3.771,2.981,3.771s2.981-1.6,2.981-3.816c0-1.671-.836-3.771-2.958-3.771s-3.026,1.942-3.026,3.816Z",
    transform: "translate(80.72 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38548",
    "data-name": "Path 38548",
    d: "M328.22,771.222l-.135-1.242h-.068a3.663,3.663,0,0,1-3,1.468,2.8,2.8,0,0,1-3-2.823c0-2.371,2.123-3.681,5.917-3.658v-.2a2.032,2.032,0,0,0-2.236-2.281,4.964,4.964,0,0,0-2.552.723l-.406-1.174a6.175,6.175,0,0,1,3.229-.881c3,0,3.749,2.055,3.749,4.02v3.681a14.581,14.581,0,0,0,.158,2.349h-1.626Zm-.271-5.013c-1.942-.045-4.178.294-4.178,2.213a1.593,1.593,0,0,0,1.694,1.716,2.418,2.418,0,0,0,2.371-1.648,1.641,1.641,0,0,0,.09-.565v-1.716Z",
    transform: "translate(86.911 -756.769)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38549",
    "data-name": "Path 38549",
    d: "M335.584,759.22v11.9a22.241,22.241,0,0,0,.09,2.552h-1.6l-.09-1.716h-.045a3.619,3.619,0,0,1-3.365,1.942c-2.371,0-4.2-2.01-4.2-4.991,0-3.274,2.01-5.284,4.4-5.284a3.249,3.249,0,0,1,2.958,1.513h.045v-5.871h1.784Zm-1.784,8.6a2.111,2.111,0,0,0-.09-.745A2.649,2.649,0,0,0,331.135,765c-1.852,0-2.958,1.626-2.958,3.794,0,1.987.971,3.636,2.913,3.636a2.677,2.677,0,0,0,2.62-2.145,2.862,2.862,0,0,0,.09-.768V767.8Z",
    transform: "translate(92.396 -759.197)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38550",
    "data-name": "Path 38550",
    d: "M331.81,764.053a24.33,24.33,0,0,0-.09-2.665h1.558l.09,1.581h.068a3.4,3.4,0,0,1,3.094-1.807,2.913,2.913,0,0,1,2.778,1.965h.045a4.165,4.165,0,0,1,1.107-1.287,3.329,3.329,0,0,1,2.168-.7c1.31,0,3.229.858,3.229,4.268v5.8h-1.739v-5.578c0-1.9-.7-3.026-2.145-3.026a2.33,2.33,0,0,0-2.123,1.626,2.715,2.715,0,0,0-.135.9v6.075h-1.739v-5.894c0-1.558-.7-2.71-2.055-2.71a2.428,2.428,0,0,0-2.213,1.784,2.769,2.769,0,0,0-.135.881v5.939h-1.739v-7.181Z",
    transform: "translate(99.128 -756.781)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38551",
    "data-name": "Path 38551",
    d: "M341.2,759.784a17.334,17.334,0,0,1,3.229-.294,5.8,5.8,0,0,1,3.771.994,2.813,2.813,0,0,1,1.129,2.416,3.256,3.256,0,0,1-2.326,3v.045a3.51,3.51,0,0,1,2.823,3.433,3.694,3.694,0,0,1-1.152,2.733c-.948.881-2.507,1.287-4.742,1.287a23.259,23.259,0,0,1-2.732-.158V759.761Zm1.761,5.623h1.6c1.874,0,2.958-.971,2.958-2.3,0-1.6-1.219-2.236-3-2.236a9.054,9.054,0,0,0-1.558.113v4.4Zm0,6.571a8.526,8.526,0,0,0,1.49.09c1.829,0,3.523-.677,3.523-2.665,0-1.874-1.6-2.642-3.545-2.642h-1.468Z",
    transform: "translate(111.056 -758.858)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38552",
    "data-name": "Path 38552",
    d: "M346.1,764.447c0-1.152,0-2.145-.09-3.071h1.558l.068,1.942h.09a2.968,2.968,0,0,1,2.732-2.168,1.155,1.155,0,0,1,.5.068v1.694a2.391,2.391,0,0,0-.61-.068,2.5,2.5,0,0,0-2.394,2.3,4.513,4.513,0,0,0-.09.836v5.239H346.1Z",
    transform: "translate(117.108 -756.769)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38553",
    "data-name": "Path 38553",
    d: "M351.143,760.659a1.107,1.107,0,1,1-2.213,0,1.118,1.118,0,0,1,1.129-1.129,1.086,1.086,0,0,1,1.107,1.129Zm-1.987,12.6v-9.846h1.784v9.846Z",
    transform: "translate(120.782 -758.807)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38554",
    "data-name": "Path 38554",
    d: "M360,761.363c-.045.723-.09,1.513-.09,2.71v5.713c0,2.258-.452,3.636-1.4,4.494a5.165,5.165,0,0,1-3.568,1.174,6.335,6.335,0,0,1-3.274-.813l.452-1.355a5.579,5.579,0,0,0,2.891.768c1.829,0,3.184-.948,3.184-3.432v-1.107h-.045a3.53,3.53,0,0,1-3.139,1.649c-2.439,0-4.178-2.078-4.178-4.787,0-3.342,2.168-5.217,4.426-5.217a3.273,3.273,0,0,1,3.071,1.716h.045l.09-1.49h1.558Zm-1.852,3.884a2.305,2.305,0,0,0-.09-.813,2.572,2.572,0,0,0-2.507-1.9c-1.716,0-2.936,1.445-2.936,3.726,0,1.919.971,3.545,2.913,3.545a2.621,2.621,0,0,0,2.484-1.829,3.438,3.438,0,0,0,.135-.948V765.27Z",
    transform: "translate(123.173 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38555",
    "data-name": "Path 38555",
    d: "M356.17,759.233h1.784v6.142H358a3.3,3.3,0,0,1,1.287-1.265,3.76,3.76,0,0,1,1.829-.519c1.31,0,3.432.813,3.432,4.2v5.849h-1.784v-5.646c0-1.581-.587-2.936-2.281-2.936a2.563,2.563,0,0,0-2.394,1.784,1.982,1.982,0,0,0-.113.858v5.939h-1.784V759.21Z",
    transform: "translate(129.892 -759.21)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38556",
    "data-name": "Path 38556",
    d: "M363.9,760v2.823h2.552v1.355H363.9v5.307c0,1.219.339,1.919,1.332,1.919a4.943,4.943,0,0,0,1.039-.113l.09,1.332a4.515,4.515,0,0,1-1.581.248,2.549,2.549,0,0,1-1.942-.745,3.56,3.56,0,0,1-.7-2.552V764.2H360.63v-1.355h1.513V760.5l1.739-.474Z",
    transform: "translate(135.503 -758.216)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38557",
    "data-name": "Path 38557",
    d: "M373.36,766.218c0,3.636-2.529,5.216-4.9,5.216-2.665,0-4.72-1.942-4.72-5.058,0-3.3,2.145-5.217,4.878-5.217A4.715,4.715,0,0,1,373.36,766.218Zm-7.813.09c0,2.145,1.242,3.771,2.981,3.771s2.981-1.6,2.981-3.816c0-1.671-.836-3.771-2.958-3.771s-3.026,1.942-3.026,3.816Z",
    transform: "translate(139.416 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38558",
    "data-name": "Path 38558",
    d: "M369.04,764.041a24.33,24.33,0,0,0-.09-2.665h1.581l.09,1.626h.045a3.647,3.647,0,0,1,3.252-1.852c1.355,0,3.478.813,3.478,4.2v5.871h-1.784v-5.668c0-1.581-.587-2.913-2.281-2.913a2.532,2.532,0,0,0-2.394,1.829,2.34,2.34,0,0,0-.113.836v5.917H369.04V764.04Z",
    transform: "translate(145.972 -756.769)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38559",
    "data-name": "Path 38559",
    d: "M373.493,769.538a29.333,29.333,0,0,0,1.219-4.855l1.987-.2a24.251,24.251,0,0,1-1.942,4.946l-1.287.113Z",
    transform: "translate(151.659 -752.579)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38560",
    "data-name": "Path 38560",
    d: "M384.881,766.822h-5.329v4.946h5.939v1.49h-7.7V759.55H385.2v1.49h-5.623v4.336H384.9v1.468Z",
    transform: "translate(157.095 -758.782)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38561",
    "data-name": "Path 38561",
    d: "M388.06,771.222l-.135-1.242h-.068a3.663,3.663,0,0,1-3,1.468,2.8,2.8,0,0,1-3-2.823c0-2.371,2.123-3.681,5.917-3.658v-.2a2.032,2.032,0,0,0-2.236-2.281,4.964,4.964,0,0,0-2.552.723l-.406-1.174a6.175,6.175,0,0,1,3.229-.881c3,0,3.749,2.055,3.749,4.02v3.681a14.581,14.581,0,0,0,.158,2.349h-1.626Zm-.271-5.013c-1.942-.045-4.178.294-4.178,2.213a1.593,1.593,0,0,0,1.694,1.716,2.418,2.418,0,0,0,2.371-1.648,1.641,1.641,0,0,0,.09-.565v-1.716Z",
    transform: "translate(162.203 -756.769)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38562",
    "data-name": "Path 38562",
    d: "M386.672,769.38a4.736,4.736,0,0,0,2.349.723c1.31,0,1.92-.655,1.92-1.468s-.5-1.31-1.829-1.807c-1.761-.632-2.6-1.6-2.6-2.778,0-1.581,1.287-2.891,3.387-2.891a4.985,4.985,0,0,1,2.416.61l-.452,1.31a3.809,3.809,0,0,0-2.01-.565c-1.061,0-1.649.61-1.649,1.332,0,.813.587,1.174,1.874,1.671,1.716.655,2.574,1.513,2.574,2.958,0,1.739-1.332,2.958-3.681,2.958a5.516,5.516,0,0,1-2.755-.677l.452-1.355Z",
    transform: "translate(167.701 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38563",
    "data-name": "Path 38563",
    d: "M392.864,760v2.823h2.552v1.355h-2.552v5.307c0,1.219.339,1.919,1.332,1.919a4.942,4.942,0,0,0,1.039-.113l.09,1.332a4.515,4.515,0,0,1-1.581.248,2.549,2.549,0,0,1-1.942-.745,3.56,3.56,0,0,1-.7-2.552V764.2H389.59v-1.355H391.1V760.5l1.739-.474Z",
    transform: "translate(171.942 -758.216)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38564",
    "data-name": "Path 38564",
    d: "M395.139,771.228a6.14,6.14,0,0,0,3.161.9c1.807,0,2.868-.948,2.868-2.349,0-1.287-.723-2.01-2.574-2.733-2.236-.79-3.613-1.942-3.613-3.884,0-2.145,1.761-3.726,4.426-3.726a6.036,6.036,0,0,1,3.026.677l-.5,1.445a5.381,5.381,0,0,0-2.6-.655c-1.874,0-2.574,1.129-2.574,2.055,0,1.287.836,1.919,2.732,2.642,2.326.9,3.5,2.01,3.5,4.02,0,2.123-1.558,3.952-4.787,3.952a7.072,7.072,0,0,1-3.5-.881l.452-1.49Z",
    transform: "translate(178.384 -758.92)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38565",
    "data-name": "Path 38565",
    d: "M407.665,768.409a24.325,24.325,0,0,0,.09,2.687h-1.581l-.09-1.6h-.045a3.727,3.727,0,0,1-3.252,1.829c-1.536,0-3.387-.858-3.387-4.313V761.25h1.784v5.442c0,1.874.565,3.139,2.19,3.139a2.568,2.568,0,0,0,2.349-1.626,2.942,2.942,0,0,0,.158-.926V761.25h1.784v7.158Z",
    transform: "translate(184.285 -756.643)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38566",
    "data-name": "Path 38566",
    d: "M404.512,769.38a4.736,4.736,0,0,0,2.349.723c1.31,0,1.919-.655,1.919-1.468s-.5-1.31-1.829-1.807c-1.761-.632-2.6-1.6-2.6-2.778,0-1.581,1.287-2.891,3.387-2.891a4.986,4.986,0,0,1,2.416.61l-.452,1.31a3.809,3.809,0,0,0-2.01-.565c-1.061,0-1.649.61-1.649,1.332,0,.813.587,1.174,1.874,1.671,1.716.655,2.574,1.513,2.574,2.958,0,1.739-1.332,2.958-3.681,2.958a5.516,5.516,0,0,1-2.755-.677l.452-1.355Z",
    transform: "translate(190.148 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38567",
    "data-name": "Path 38567",
    d: "M408.082,769.38a4.736,4.736,0,0,0,2.349.723c1.31,0,1.919-.655,1.919-1.468s-.5-1.31-1.829-1.807c-1.761-.632-2.6-1.6-2.6-2.778,0-1.581,1.287-2.891,3.387-2.891a4.986,4.986,0,0,1,2.416.61l-.452,1.31a3.809,3.809,0,0,0-2.01-.565c-1.061,0-1.649.61-1.649,1.332,0,.813.587,1.174,1.874,1.671,1.716.655,2.574,1.513,2.574,2.958,0,1.739-1.332,2.958-3.681,2.958a5.517,5.517,0,0,1-2.755-.677l.452-1.355Z",
    transform: "translate(194.64 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38568",
    "data-name": "Path 38568",
    d: "M412.884,766.625a3.147,3.147,0,0,0,3.365,3.41,6.765,6.765,0,0,0,2.732-.5l.316,1.287a7.864,7.864,0,0,1-3.274.61c-3.026,0-4.833-1.987-4.833-4.968s1.739-5.307,4.607-5.307c3.207,0,4.065,2.823,4.065,4.629a6.159,6.159,0,0,1-.068.835h-6.91Zm5.239-1.287c0-1.129-.474-2.913-2.484-2.913-1.807,0-2.6,1.671-2.732,2.913Z",
    transform: "translate(199.119 -756.756)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38569",
    "data-name": "Path 38569",
    d: "M417.558,761.25l1.4,2.123c.361.542.677,1.061.994,1.6h.068c.316-.587.655-1.107.971-1.626l1.378-2.1h1.942l-3.365,4.765L424.4,771.1h-2.032l-1.445-2.213c-.384-.565-.7-1.129-1.061-1.716h-.045c-.316.587-.677,1.129-1.039,1.716l-1.423,2.213H415.39l3.5-5.013-3.342-4.81h1.987Z",
    transform: "translate(204.404 -756.643)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38570",
    "data-name": "Path 38570",
    d: "M422.08,759.784a17.334,17.334,0,0,1,3.229-.294,5.8,5.8,0,0,1,3.771.994,2.813,2.813,0,0,1,1.129,2.416,3.256,3.256,0,0,1-2.326,3v.045a3.51,3.51,0,0,1,2.823,3.433,3.694,3.694,0,0,1-1.152,2.733c-.948.881-2.507,1.287-4.742,1.287a23.259,23.259,0,0,1-2.732-.158V759.761Zm1.761,5.623h1.6c1.874,0,2.958-.971,2.958-2.3,0-1.6-1.219-2.236-3-2.236a9.053,9.053,0,0,0-1.558.113v4.4Zm0,6.571a8.526,8.526,0,0,0,1.49.09c1.829,0,3.523-.677,3.523-2.665,0-1.874-1.6-2.642-3.545-2.642h-1.468Z",
    transform: "translate(212.822 -758.858)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38571",
    "data-name": "Path 38571",
    d: "M426.96,773.247V759.54h1.919l4.4,6.933a39.5,39.5,0,0,1,2.461,4.449h.045c-.158-1.852-.2-3.523-.2-5.646V759.54h1.671v13.708h-1.784l-4.358-6.955a40.648,40.648,0,0,1-2.552-4.584H428.5c.09,1.739.135,3.387.135,5.668v5.849H426.96Z",
    transform: "translate(218.962 -758.795)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38572",
    "data-name": "Path 38572",
    d: "M435.827,761.418h-.045l-2.3,1.242-.339-1.355,2.891-1.536h1.513v13.211h-1.716v-11.54Z",
    transform: "translate(226.738 -758.505)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38573",
    "data-name": "Path 38573",
    d: "M440.232,771.844a6.742,6.742,0,0,0,1.445-.068,4.819,4.819,0,0,0,2.755-1.287,5.633,5.633,0,0,0,1.739-3.523H446.1a3.976,3.976,0,0,1-7.023-2.62,4.527,4.527,0,0,1,4.516-4.7c2.71,0,4.381,2.19,4.381,5.578a8.337,8.337,0,0,1-2.281,6.21,6.576,6.576,0,0,1-3.839,1.761,8.969,8.969,0,0,1-1.648.09v-1.468Zm.655-7.61a2.533,2.533,0,0,0,2.529,2.8,2.934,2.934,0,0,0,2.6-1.377,1.268,1.268,0,0,0,.158-.655c0-2.258-.836-3.974-2.71-3.974-1.513,0-2.6,1.332-2.6,3.207Z",
    transform: "translate(234.211 -758.656)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38574",
    "data-name": "Path 38574",
    d: "M445.791,759.54v5.736h6.617V759.54h1.784v13.708h-1.784v-6.413h-6.617v6.413H444.03V759.54Z",
    transform: "translate(240.44 -758.795)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38575",
    "data-name": "Path 38575",
    d: "M451.686,759.54v8.107c0,3.071,1.355,4.381,3.184,4.381,2.032,0,3.342-1.332,3.342-4.381V759.54H460v7.994c0,4.2-2.213,5.939-5.194,5.939-2.8,0-4.923-1.6-4.923-5.849v-8.062h1.784Z",
    transform: "translate(247.8 -758.795)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38576",
    "data-name": "Path 38576",
    d: "M260.088,771.853H255.91V770.34h10.139v1.513h-4.178v12.194h-1.784V771.853Z",
    transform: "translate(3.741 -745.206)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38577",
    "data-name": "Path 38577",
    d: "M261.806,777.425a3.146,3.146,0,0,0,3.365,3.41,6.765,6.765,0,0,0,2.732-.5l.294,1.287a7.865,7.865,0,0,1-3.274.61c-3.026,0-4.833-1.987-4.833-4.968s1.739-5.307,4.607-5.307c3.207,0,4.065,2.823,4.065,4.629a6.161,6.161,0,0,1-.068.836h-6.91Zm5.239-1.287c0-1.129-.474-2.913-2.484-2.913-1.807,0-2.6,1.671-2.755,2.913h5.216Z",
    transform: "translate(9.001 -743.167)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38578",
    "data-name": "Path 38578",
    d: "M264.92,770.02H266.7v14.43H264.92Z",
    transform: "translate(15.078 -745.608)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38579",
    "data-name": "Path 38579",
    d: "M266.85,773.487a1.218,1.218,0,0,1,1.219-1.287,1.2,1.2,0,0,1,1.2,1.287,1.209,1.209,0,1,1-2.416,0Zm0,7.181a1.218,1.218,0,0,1,1.219-1.287,1.278,1.278,0,0,1-.023,2.552A1.181,1.181,0,0,1,266.85,780.668Z",
    transform: "translate(17.506 -742.865)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38580",
    "data-name": "Path 38580",
    d: "M276.414,771.62v4.787H281v1.219h-4.584v4.81H275.1v-4.81H270.52v-1.219H275.1V771.62Z",
    transform: "translate(22.124 -743.595)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38581",
    "data-name": "Path 38581",
    d: "M281.792,783.771V780.18H275.65v-1.174l5.894-8.446h1.942v8.22h1.852v1.4h-1.852v3.591h-1.694Zm0-4.991v-4.4c0-.7,0-1.377.068-2.078h-.068c-.406.768-.723,1.332-1.107,1.942l-3.229,4.494v.045h4.336Z",
    transform: "translate(28.579 -744.929)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38582",
    "data-name": "Path 38582",
    d: "M286.412,783.771V780.18H280.27v-1.174l5.894-8.446h1.942v8.22h1.852v1.4h-1.852v3.591h-1.694Zm0-4.991v-4.4c0-.7,0-1.377.068-2.078h-.068c-.406.768-.723,1.332-1.107,1.942l-3.229,4.494v.045h4.336Z",
    transform: "translate(34.392 -744.929)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38583",
    "data-name": "Path 38583",
    d: "M290.287,772.218h-.045l-2.3,1.242-.339-1.355,2.891-1.536H292v13.211h-1.739V772.241Z",
    transform: "translate(43.615 -744.916)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38584",
    "data-name": "Path 38584",
    d: "M291.68,783.884v-1.106l1.4-1.355c3.365-3.207,4.9-4.923,4.923-6.91a2.357,2.357,0,0,0-2.62-2.574,4.434,4.434,0,0,0-2.8,1.129l-.565-1.265a5.794,5.794,0,0,1,3.749-1.332,3.71,3.71,0,0,1,4.042,3.839c0,2.439-1.761,4.4-4.562,7.091l-1.061.971v.045h5.939v1.49H291.68Z",
    transform: "translate(48.748 -745.042)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38585",
    "data-name": "Path 38585",
    d: "M299.517,772.218h-.045l-2.3,1.242-.339-1.355,2.891-1.536h1.513v13.211h-1.739V772.241Z",
    transform: "translate(55.228 -744.916)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38586",
    "data-name": "Path 38586",
    d: "M309.363,770.573v1.174L303.6,783.783h-1.852l5.736-11.7v-.045H301.03v-1.49h8.333Z",
    transform: "translate(60.513 -744.942)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38587",
    "data-name": "Path 38587",
    d: "M306,781.829a6.065,6.065,0,0,0,2.936.836c2.3,0,3-1.468,2.981-2.552,0-1.852-1.694-2.642-3.41-2.642h-.994v-1.332h.994c1.31,0,2.936-.677,2.936-2.236,0-1.061-.677-1.987-2.326-1.987a4.828,4.828,0,0,0-2.642.881l-.474-1.31a6.4,6.4,0,0,1,3.455-1.016c2.6,0,3.771,1.536,3.771,3.161a3.292,3.292,0,0,1-2.439,3.116v.045a3.435,3.435,0,0,1,2.958,3.387c0,2.123-1.649,3.952-4.81,3.952a6.668,6.668,0,0,1-3.432-.9l.5-1.378Z",
    transform: "translate(66.137 -745.042)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38588",
    "data-name": "Path 38588",
    d: "M311.99,780.544A3.787,3.787,0,0,1,314.61,777v-.068a3.269,3.269,0,0,1-2.123-2.958c0-2.1,1.761-3.523,4.087-3.523,2.552,0,3.839,1.6,3.839,3.252a3.339,3.339,0,0,1-2.168,3.094v.068a3.663,3.663,0,0,1,2.665,3.41c0,2.3-1.965,3.839-4.494,3.839-2.755,0-4.426-1.649-4.426-3.568Zm7.113-.09c0-1.6-1.129-2.371-2.913-2.891a2.882,2.882,0,0,0-2.371,2.733,2.447,2.447,0,0,0,2.642,2.529,2.342,2.342,0,0,0,2.642-2.349Zm-4.923-6.617c0,1.31.994,2.032,2.529,2.439a2.606,2.606,0,0,0,2.01-2.394,2.046,2.046,0,0,0-2.236-2.145,2.1,2.1,0,0,0-2.3,2.123Z",
    transform: "translate(74.303 -745.067)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38589",
    "data-name": "Path 38589",
    d: "M319.9,772.218h-.045l-2.3,1.242-.339-1.355,2.891-1.536h1.513v13.211H319.9V772.241Z",
    transform: "translate(80.871 -744.916)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38590",
    "data-name": "Path 38590",
    d: "M324.507,772.218h-.045l-2.3,1.242-.339-1.355,2.891-1.536h1.513v13.211h-1.716V772.241Z",
    transform: "translate(86.671 -744.916)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38591",
    "data-name": "Path 38591",
    d: "M334.8,777.144c0,4.494-1.671,6.978-4.584,6.978-2.574,0-4.336-2.416-4.381-6.8,0-4.426,1.919-6.865,4.584-6.865s4.381,2.484,4.381,6.684Zm-7.181.2c0,3.432,1.061,5.4,2.687,5.4,1.829,0,2.71-2.145,2.71-5.51s-.836-5.4-2.687-5.4C328.766,771.838,327.614,773.757,327.614,777.348Z",
    transform: "translate(91.717 -745.055)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38592",
    "data-name": "Path 38592",
    d: "M333.747,772.218H333.7l-2.3,1.242-.339-1.355,2.891-1.536h1.513v13.211h-1.716V772.241Z",
    transform: "translate(98.297 -744.916)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38593",
    "data-name": "Path 38593",
    d: "M338.367,772.218h-.045l-2.3,1.242-.339-1.355,2.891-1.536h1.513v13.211h-1.716V772.241Z",
    transform: "translate(104.11 -744.916)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38594",
    "data-name": "Path 38594",
    d: "M258.951,794.847,254.48,781.14H256.4l2.145,6.752c.587,1.852,1.107,3.523,1.468,5.126h.045c.384-1.581.948-3.319,1.558-5.1l2.326-6.775h1.9l-4.9,13.708H259Z",
    transform: "translate(1.942 -731.617)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38595",
    "data-name": "Path 38595",
    d: "M262.422,790.534,261,794.847H259.17l4.652-13.708h2.145l4.674,13.708h-1.9l-1.468-4.313h-4.855Zm4.494-1.377-1.332-3.952c-.316-.9-.519-1.716-.723-2.507h-.045c-.2.813-.429,1.648-.7,2.484l-1.332,3.974Z",
    transform: "translate(7.843 -731.617)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38596",
    "data-name": "Path 38596",
    d: "M267.928,782.653H263.75V781.14h10.139v1.513h-4.178v12.195h-1.784V782.653Z",
    transform: "translate(13.606 -731.617)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38597",
    "data-name": "Path 38597",
    d: "M270.83,794.847V781.14h1.942l4.381,6.933a39.5,39.5,0,0,1,2.461,4.449h.045c-.158-1.852-.2-3.523-.2-5.646V781.14h1.671v13.708h-1.784l-4.358-6.955a40.649,40.649,0,0,1-2.552-4.584h-.068c.09,1.739.135,3.387.135,5.668v5.849H270.83Z",
    transform: "translate(22.514 -731.617)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38598",
    "data-name": "Path 38598",
    d: "M286.03,787.818c0,3.636-2.529,5.216-4.9,5.216-2.665,0-4.72-1.942-4.72-5.058,0-3.3,2.145-5.217,4.878-5.217A4.715,4.715,0,0,1,286.03,787.818Zm-7.813.09c0,2.145,1.242,3.771,2.981,3.771s2.981-1.6,2.981-3.816c0-1.671-.836-3.771-2.958-3.771s-3.026,1.942-3.026,3.816Z",
    transform: "translate(29.535 -729.578)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38599",
    "data-name": "Path 38599",
    d: "M281.47,784.287A1.218,1.218,0,0,1,282.689,783a1.2,1.2,0,0,1,1.2,1.287,1.209,1.209,0,1,1-2.416,0Zm0,7.181a1.218,1.218,0,0,1,1.219-1.287,1.278,1.278,0,0,1-.023,2.552A1.181,1.181,0,0,1,281.47,791.468Z",
    transform: "translate(35.902 -729.277)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38600",
    "data-name": "Path 38600",
    d: "M296.346,794.313a12.489,12.489,0,0,1-4.2.745,6.444,6.444,0,0,1-7.046-6.91c0-4.087,2.823-7.068,7.43-7.068a8.288,8.288,0,0,1,3.41.632l-.429,1.445a7.216,7.216,0,0,0-3.026-.587,5.123,5.123,0,0,0-5.51,5.51c0,3.433,2.1,5.533,5.284,5.533a5.761,5.761,0,0,0,2.349-.361v-4.087H291.83v-1.423h4.516v6.594Z",
    transform: "translate(40.469 -731.692)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38601",
    "data-name": "Path 38601",
    d: "M291.283,781.383a17.334,17.334,0,0,1,3.229-.294,5.8,5.8,0,0,1,3.771.994,2.871,2.871,0,0,1,1.129,2.416,3.256,3.256,0,0,1-2.326,3v.045a3.51,3.51,0,0,1,2.823,3.432,3.694,3.694,0,0,1-1.152,2.733c-.948.881-2.507,1.287-4.742,1.287a24.065,24.065,0,0,1-2.755-.158V781.361Zm1.761,5.623h1.6c1.874,0,2.958-.971,2.958-2.3,0-1.6-1.219-2.236-3-2.236a9.053,9.053,0,0,0-1.558.113v4.4Zm0,6.571a8.54,8.54,0,0,0,1.49.09c1.829,0,3.523-.677,3.523-2.665,0-1.874-1.6-2.642-3.545-2.642h-1.468Z",
    transform: "translate(48.22 -731.68)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38602",
    "data-name": "Path 38602",
    d: "M297.78,794.684v-1.107l1.4-1.355c3.365-3.207,4.9-4.923,4.923-6.91a2.357,2.357,0,0,0-2.62-2.574,4.433,4.433,0,0,0-2.8,1.129l-.565-1.265a5.8,5.8,0,0,1,3.749-1.332,3.71,3.71,0,0,1,4.042,3.839c0,2.439-1.761,4.4-4.562,7.091l-1.061.971v.045h5.939v1.49H297.78Z",
    transform: "translate(56.424 -731.453)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38603",
    "data-name": "Path 38603",
    d: "M305.617,783.018h-.045l-2.3,1.242-.339-1.355,2.891-1.536h1.513v13.211h-1.716v-11.54Z",
    transform: "translate(62.903 -731.328)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38604",
    "data-name": "Path 38604",
    d: "M308.112,793.444a6.741,6.741,0,0,0,1.445-.068,4.82,4.82,0,0,0,2.755-1.287,5.632,5.632,0,0,0,1.739-3.523h-.068a3.976,3.976,0,0,1-7.023-2.62,4.527,4.527,0,0,1,4.516-4.7c2.71,0,4.381,2.19,4.381,5.578a8.337,8.337,0,0,1-2.281,6.21,6.576,6.576,0,0,1-3.839,1.761,8.97,8.97,0,0,1-1.649.09v-1.468Zm.655-7.61a2.533,2.533,0,0,0,2.529,2.8,2.934,2.934,0,0,0,2.6-1.377,1.268,1.268,0,0,0,.158-.655c0-2.258-.836-3.975-2.71-3.975-1.536,0-2.6,1.333-2.6,3.207Z",
    transform: "translate(67.974 -731.479)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38605",
    "data-name": "Path 38605",
    d: "M316.757,783.018h-.045l-2.3,1.242-.339-1.355,2.891-1.536h1.513v13.211h-1.716v-11.54Z",
    transform: "translate(76.92 -731.328)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38606",
    "data-name": "Path 38606",
    d: "M318.08,791.344a3.787,3.787,0,0,1,2.62-3.545v-.068a3.269,3.269,0,0,1-2.123-2.958c0-2.1,1.761-3.523,4.087-3.523,2.552,0,3.839,1.6,3.839,3.252a3.339,3.339,0,0,1-2.168,3.094v.068a3.663,3.663,0,0,1,2.665,3.41c0,2.3-1.965,3.839-4.494,3.839-2.755,0-4.426-1.648-4.426-3.568Zm7.113-.09c0-1.6-1.129-2.371-2.913-2.891a2.882,2.882,0,0,0-2.371,2.733,2.447,2.447,0,0,0,2.642,2.529,2.342,2.342,0,0,0,2.642-2.349Zm-4.923-6.617c0,1.31.994,2.032,2.529,2.439a2.606,2.606,0,0,0,2.01-2.394,2.046,2.046,0,0,0-2.236-2.145,2.1,2.1,0,0,0-2.3,2.123Z",
    transform: "translate(81.966 -731.479)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38607",
    "data-name": "Path 38607",
    d: "M325.987,783.018h-.045l-2.3,1.242-.339-1.355,2.891-1.536H327.7v13.211h-1.716v-11.54Z",
    transform: "translate(88.534 -731.328)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38608",
    "data-name": "Path 38608",
    d: "M328.492,793.444a6.741,6.741,0,0,0,1.445-.068,4.82,4.82,0,0,0,2.755-1.287,5.632,5.632,0,0,0,1.739-3.523h-.068a3.976,3.976,0,0,1-7.023-2.62,4.527,4.527,0,0,1,4.516-4.7c2.71,0,4.381,2.19,4.381,5.578a8.337,8.337,0,0,1-2.281,6.21,6.576,6.576,0,0,1-3.839,1.761,8.97,8.97,0,0,1-1.649.09v-1.468Zm.655-7.61a2.533,2.533,0,0,0,2.529,2.8,2.934,2.934,0,0,0,2.6-1.377,1.268,1.268,0,0,0,.158-.655c0-2.258-.836-3.975-2.71-3.975-1.513,0-2.6,1.333-2.6,3.207Z",
    transform: "translate(93.617 -731.479)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38609",
    "data-name": "Path 38609",
    d: "M333.112,793.444a6.741,6.741,0,0,0,1.445-.068,4.82,4.82,0,0,0,2.755-1.287,5.632,5.632,0,0,0,1.739-3.523h-.068a3.976,3.976,0,0,1-7.023-2.62,4.527,4.527,0,0,1,4.516-4.7c2.71,0,4.381,2.19,4.381,5.578a8.337,8.337,0,0,1-2.281,6.21,6.576,6.576,0,0,1-3.839,1.761,8.97,8.97,0,0,1-1.649.09v-1.468Zm.655-7.61a2.533,2.533,0,0,0,2.529,2.8,2.934,2.934,0,0,0,2.6-1.377,1.268,1.268,0,0,0,.158-.655c0-2.258-.836-3.975-2.71-3.975-1.513,0-2.6,1.333-2.6,3.207Z",
    transform: "translate(99.43 -731.479)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38610",
    "data-name": "Path 38610",
    d: "M339.847,783.018H339.8l-2.3,1.242-.339-1.355,2.891-1.536h1.513v13.211h-1.716v-11.54Z",
    transform: "translate(105.973 -731.328)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Payment_terms:_30_Days_end_of_month.",
    "data-name": "Payment terms: 30 Days end of month.",
    transform: "translate(67.024 1418.479)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.02em"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ayment terms: 30 Da"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "s end of month.")), /*#__PURE__*/React.createElement("text", {
    id: "You_can_pay_your_invoice_using_Credit_Debit_Card_or_bank_transfer_via_world_pay.",
    "data-name": "You can pay your invoice using Credit/ Debit Card or bank transfer via world pay.",
    transform: "translate(67.002 1462.604)",
    fill: "#3c3c3b",
    fontSize: 20,
    fontFamily: "myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.09em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ou can p"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "y "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "our i"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.02em"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "oice using Credit/ Debit Card or bank trans"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "er via "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.01em"
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "orld pa"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.04em"
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, ".")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceDueGbp);
export default __webpack_public_path__ + "static/media/InvoiceDueGBP.5eb2f94cfef0658a2f38cd35154bdb1b.svg";
export { ForwardRef as ReactComponent };